import { AlertDescription, AlertTitle } from '@chakra-ui/react';
import { Alert } from '@/components/ui/alert';
import type { InvitableProgramResponse } from '@/types/affiliate-programs';

interface NoInvitableProgramsMessageProps {
  programs: InvitableProgramResponse[];
}

const NoInvitableProgramsMessage: React.FC<NoInvitableProgramsMessageProps> = ({ programs }) => {
  const allProgramsDisabled = programs.every(
    (program) => !program.isExpired && program.lastInvitationDate !== null
  );

  if (!allProgramsDisabled || programs.length === 0) {
    return null; // Don't render anything if there are invitable programs or no programs at all
  }

  return (
    <Alert status="warning" rounded="md" colorPalette="primary" p={4} mb={4} variant="subtle">
      <AlertTitle>No Invitable Programs</AlertTitle>
      <AlertDescription>
        This creator has already been invited to all your active affiliate programs recently.
      </AlertDescription>
    </Alert>
  );
};

export default NoInvitableProgramsMessage;
